var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"introduction-header",on:{"click":_vm.showModal}},[_c('h2',[_vm._v(_vm._s(_vm.title))]),_c('p',[_vm._v(_vm._s(_vm.desc))]),(_vm.type === 'company')?_c('div',{staticClass:"introduction-arrow"}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }